import {
    differenceInDays, subDays,
} from '@shared/wrappers/date/date';

export function calculatePreviousPeriod({ startDate, endDate }) {
    const diffDays = differenceInDays(endDate, startDate);

    const startDateForComparison = subDays(startDate, diffDays + 1);
    const endDateForComparison = subDays(endDate, diffDays + 1);

    return { startDateForComparison, endDateForComparison };
}
